export const getEmailTypes = ({ pages }) => pages.emailTypes

export const getDbEmailCards =
  (dbID) =>
  ({ pages, display }) =>
    pages?.emailCards?.filter(
      ({ parent, type }) => parent.database_id === dbID && type.includes(display.typeFilter)
    )
